require('../customer_application_bootstrap/angular/dependencies');

const { default: startApp, defaultRun } = require('../customer_application_bootstrap/angular/avant');
const { renderReact } = require('../customer_application_bootstrap/angular/react');

startApp(defaultRun(renderReact));

window.angular = angular;

class WelcomeBackController{
  constructor($scope, $controller, AuthenticationService, $http, $window, HeapService, $timeout){
    $scope.spinnerUrl = require('@amount/frontend-styles/src/images/dec/dec-loading.svg')

    $scope.getToken = function() {
      var el;
      el = document.querySelector('meta[name="csrf-token"]');
      if (el) {
        el = el.getAttribute('content');
      } else {
        el = document.querySelector('input[name="authenticity_token"]');
        if (el) {
          el = el.value;
        }
      }
      return el;
    };

    $scope.updateToken = function() {
      var headers, token;
      headers = $http.defaults.headers.common;
      token = $scope.getToken();
      if (token) {
        headers['X-CSRF-TOKEN'] = token;
        headers['X-Requested-With'] = 'XMLHttpRequest';
      }
    };

    $scope.updateToken();

    HeapService.customerAuthenticated(false);

    $scope.error_message = null;

    $scope.redirecting_page = false;

    $scope.welcomeBackEventName = function(suffix) {
      return "app:welcome_back:" + suffix;
    };

    $scope.credentials = function() {
      return {
        email: $scope.customer_email,
        password: $scope.customer_password
      };
    };

    $scope.visitUrl = function(path, event_name) {
      $scope.redirecting_page = true;
      HeapService.track($scope.welcomeBackEventName(event_name));
      return $window.location.replace(path);
    };

    $scope.tryLogin = function() {
      $scope.signingIn = true;
      $scope.error_message = null;
      return AuthenticationService.authenticate($scope.credentials()).then(function(data) {
        $scope.error_message = null;
        HeapService.customerAuthenticated(true);
        return $scope.visitUrl("/apply", "success");
      })["catch"](function(response) {
        $scope.error_message = response.data != null ? response.data.error : "Invalid email or password.";
        $scope.signingIn = false;
        return HeapService.track($scope.welcomeBackEventName("error"));
      });
    };

    // NO BUENO, REFACTOR THIS OUT
    // $timeout(function(){
    //   $('.header__drawer-link').hide();
    // });
    // ---
    // generated by coffee-script 1.9.2

  }
}

WelcomeBackController.$inject = [
  "$scope",
  "$controller",
  "AuthenticationService",
  "$http",
  "$window",
  "HeapService",
  "$timeout",
];

angular
.module("angularAvant")
.controller("WelcomeBackController", WelcomeBackController)

module.exports = WelcomeBackController

const BaseAvantRouter = require('angular/avantRouter.js')

class AwesomeAvantRouter extends BaseAvantRouter{
  constructor($httpProvider, $stateProvider, $sceDelegateProvider, $urlMatcherFactoryProvider){
    super(...arguments)

    delete this.states.loading.controllerProvider
    delete this.states.loading.templateUrl

    Object.assign(this.states.loading, {
      controller: `WelcomeBackController`,
      templateUrl: function(){
        return '/customer_sessions/welcome_back.html';
      }
    })

  }
}

AwesomeAvantRouter.$inject = [
  "$httpProvider",
  "$stateProvider",
  "$sceDelegateProvider",
  "$urlMatcherFactoryProvider",
];

angular
.module("avant.customer_applications.factories")
.provider("avantRouter", AwesomeAvantRouter)

module.exports = AwesomeAvantRouter

